import gray from 'gray-percentage'
import Typography from 'typography'
import lincolnTheme from 'typography-theme-lincoln'
import { extend } from 'lodash'

const linkColor = `#212121`
const themeColor = `#f44336`

lincolnTheme.overrideThemeStyles = ({ rhythm, scale }, options) => ({
  // 'h1,h2,h3,h4,h5,h6': {
  //   marginTop: rhythm(1.5),
  //   marginBottom: rhythm(0.5),
  //   fontFamily: 'Open Sans'
  // },
  // blockquote: {
  //   ...scale(1 / 5),
  //   borderLeft: `${rhythm(6 / 16)} solid ${themeColor}`,
  //   color: gray(35),
  //   paddingLeft: rhythm(10 / 16),
  //   fontStyle: 'italic',
  //   marginLeft: 0,
  //   marginRight: 0,
  // },
  // 'a:hover,a:active': {
  //   color: linkColor,
  //   textShadow: 'none',
  //   backgroundImage: 'none',
  // },
  // a: {
  //   textDecoration: 'none',
  //   textShadow:
  //     '.03em 0 #fff,-.03em 0 #fff,0 .03em #fff,0 -.03em #fff,.06em 0 #fff,-.06em 0 #fff,.09em 0 #fff,-.09em 0 #fff,.12em 0 #fff,-.12em 0 #fff,.15em 0 #fff,-.15em 0 #fff', // eslint-disable-line
  //   backgroundImage: `linear-gradient(to top, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0) 1px, ${linkColor} 1px, ${linkColor} 2px, rgba(0, 0, 0, 0) 2px)`, // eslint-disable-line
  // },
  p: {
    color: '#212121'
  },
  hr: {
    marginBottom: rhythm(1),
  },
})

const typography = new Typography(lincolnTheme)

// Hot reload typography in development.
if (process.env.NODE_ENV !== 'production') {
  typography.injectStyles()
}

export default typography



// WEBPACK FOOTER //
// ./src/utils/typography.js